import React, { Context } from 'react';
import { ValidationResult } from '../../../hooks/validation/validator/FormFieldValidator';

function warnOnMethodCall(methodName: string) {
  console.warn(
    `Default method ${methodName} was called. This method was supposed to be set to some concrete implementation.`,
  );
}

export class FieldValidation {
  isFocused: boolean = false;
  isValid?: boolean = undefined;
  hasError: boolean = false;
  errorTags: string[] = [];
  validate = async () => {
    warnOnMethodCall(this.validate.name);
    return Promise.resolve(ValidationResult.create(true));
  };
  blur = () => {
    warnOnMethodCall(this.blur.name);
  };
  focus = () => {
    warnOnMethodCall(this.focus.name);
  };
  setValidationState = (isValid: boolean, hasError: boolean, errorTags: string[]) => {
    warnOnMethodCall(this.setValidationState.name);
  };

  setValidationMethod(method: () => Promise<ValidationResult>) {
    this.validate = method;
  }

  setBlurMethod(method: () => void) {
    this.blur = method;
  }

  setFocusMethod(method: () => void) {
    this.focus = method;
  }

  setChangeValidationStateMethod(
    method: (isValid: boolean, hasError: boolean, errorTags: string[]) => void,
  ) {
    this.setValidationState = method;
  }

  createUpdated(datasetForUpdate?: any) {
    return FieldValidation.from(this, datasetForUpdate);
  }

  static from(previousValue: FieldValidation, datasetForUpdate?: any) {
    const newValue = new FieldValidation();
    const fieldValidationKeys = Object.getOwnPropertyNames(previousValue);
    fieldValidationKeys.forEach((propName) => {
      // @ts-ignore
      newValue[propName as keyof FieldValidation] =
        previousValue[propName as keyof FieldValidation];
    });
    if (datasetForUpdate) {
      Object.keys(datasetForUpdate).forEach((key) => {
        if (fieldValidationKeys.includes(key)) {
          newValue[key as keyof FieldValidation] = datasetForUpdate[key];
        }
      });
    }
    return newValue;
  }
}

export const FormFieldValidationContext: Context<FieldValidation> = React.createContext(
  new FieldValidation(),
);
